import { Typography } from "@packages/ds";
import styled from "styled-components";

import { FlexWrapper } from "./services/style";

export const PageTitileContainer = styled(FlexWrapper)`
  margin-bottom: 16px;
  align-items: center;
`;

export const ProfilingHeader = styled.h1`
  font-weight: 700;
  font-size: 20px;
  margin: 0;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
  flex-wrap: wrap;
  margin-bottom: 32px;
  gap: 32px;
`;

export const Heading = styled(Typography.Title)`
  margin: auto;
  text-transform: capitalize;
`;
